import { create } from 'zustand'
import { Usage } from '../service/user'

// 사용량 정보 관련 전역 상태 관리

interface UsageStore {
  usage: Usage | null
  isLoading: boolean
  usageRefetch: (() => void) | null
  set: (payload: Partial<UsageStore>) => void
  setLoading: (loading: boolean) => void
  setRefetch: (refetch: () => void) => void
  setUsage: (usage: Usage | null) => void
  destroy: () => void
}

const useUsageStore = create<UsageStore>((set) => ({
  usage: null,
  isLoading: true,
  usageRefetch: null,
  set: (payload) => set((state) => ({ ...state, ...payload })),
  setLoading: (loading) => set({ isLoading: loading }),
  setRefetch: (refetch) => set({ usageRefetch: refetch }),
  setUsage: (usage) => set({ usage }),
  destroy: () => set({ usage: null, isLoading: true, usageRefetch: null }),
}))

export default useUsageStore
